/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { VirtualArticleNotesResponse } from '../../models/virtual-article-notes-response';

export interface GetBundleGroupVirtualArticleNotes$Params {
  organizationSiteKey: KeyType;
  groupKey: string;
  virtualArticleKey: string;
}

export function getBundleGroupVirtualArticleNotes(http: HttpClient, rootUrl: string, params: GetBundleGroupVirtualArticleNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<VirtualArticleNotesResponse>> {
  const rb = new RequestBuilder(rootUrl, getBundleGroupVirtualArticleNotes.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('groupKey', params.groupKey, {});
    rb.path('virtualArticleKey', params.virtualArticleKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VirtualArticleNotesResponse>;
    })
  );
}

getBundleGroupVirtualArticleNotes.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups/{groupKey}/virtual-articles/{virtualArticleKey}/notes';
